export const numberPercentStyle: Intl.NumberFormatOptions = {
	style: 'percent',
	maximumFractionDigits: 2,
}
